<template>
  <div class="content">

    <div class="line">

    </div>

    <div class="line">
      <div class="elem status">
        <div class="filter checkbox">
          <div class="active">
            <div class="info">
              {{ translate('device.wifi_status') }}
            </div>
            <label class="switch" @click.prevent="settings.wifi.status = !settings.wifi.status" >
              <input type="checkbox" v-model="settings.wifi.status">
              <span class="slider round"></span>
            </label>
          </div>
        </div>
      </div>

      <div class="elem">
        <div class="form-group">
          <label> {{ translate('device.wifi_ssid') }} </label>
          <input
              type="text"
              class="form-control border-input error"
              v-model="settings.wifi.ssid_name"
              :placeholder="translate('device.wifi_ssid')"
              @input="validate_input_ssid"
              :disabled="!settings.wifi.status"
          >
        </div>
      </div>

      <div class="elem">
        <div class="form-group">
          <label> {{ translate('device.wifi_password') }} </label>
          <input
              type="text"
              class="form-control border-input error"
              v-model="settings.wifi.password"
              :placeholder="translate('device.wifi_password')"
              @input="validate_input_password"
              :disabled="!settings.wifi.status"
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { maxLength } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

export default {
  name: "EditNetworkSettingsWiFi",
  props: ["device_fid", "network_settings"],

  data() {
    return {
      settings: {},
    };
  },

  created() {
    this.settings = JSON.parse(JSON.stringify(this.network_settings))
  },

  watch:{
    settings:{
      deep: true,
      handler(){
        this.$emit("update_settings", this.settings)
      }
    }
  },

  methods: {
    validate_input_ssid() {
      this.settings.wifi.ssid_name = this.settings.wifi.ssid_name.slice(0, 32)
    },
    validate_input_password() {
      this.settings.wifi.password = this.settings.wifi.password.slice(0, 32)
    },
    cancel() {
      this.$emit("close");
    },
  },
};
</script>

<style lang='scss'>
  .content{
    padding: 10px 0;
    min-height: 150px;
    .line{
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      gap: 10px;
      .elem{
        flex: 2;
        text-align: left;
        &.status{
          flex: 1;
        }
        .filter{
          margin: 0;
          .active{
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            gap: 10px;
          }
        }
      }
    }
  }
</style>
